<template>

  <div class="works_box">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="全部" name="first"></el-tab-pane>
        <el-tab-pane label="已审核" name="second"></el-tab-pane>
        <el-tab-pane label="待审核" name="third"></el-tab-pane>
        <el-tab-pane label="未通过" name="fourth"></el-tab-pane>
      </el-tabs>
      <div v-if="dataEmpty">
      <el-row :gutter="20" v-for="(item, index) in workList" :key="index" >
        <el-col  :span="6">
          <!-- <div @click="workDetailsInfo(item.id,item.activity_type)" class="grid-content bg-purple left">
            <label>{{item.typeText}}</label>
            <img  :src="item.image[0]"/>
          </div> -->
          <router-link target="_blank" :to="{path:'/workdetails/'+item.id+'/'+item.activity_type}">
            <div  class="grid-content bg-purple left">
            <label>{{item.typeText}}</label>
            <img  :src="item.image[0]"/>
            <!-- <el-image :src="item.image[0]" class="cover" ></el-image> -->
          </div>
          </router-link>
        </el-col>
        <el-col  :span="14">
          <!-- <div class="grid-content bg-purple center" @click="workDetailsInfo(item.id,item.activity_type)">
            <div class="title">
              {{item.name}}
            </div>
            <div class="text" >作者：{{item.username}}</div>
            <div class="text" >机构：{{item.from}}</div>
            <div class="text" >时间：{{item.created_at}}</div>
            <index-icons class="index-icons" :goodsnum="item.mark" :commentnum="item.comment" :looknum="item.views"></index-icons>
          </div> -->
          <router-link target="_blank" :to="{path:'/workdetails/'+item.id+'/'+item.activity_type}" >
            <div class="grid-content bg-purple center" >
            <div class="title">
              {{item.name}}
            </div>
            <div class="text" >作者：{{item.username}}</div>
            <div class="text" >机构：{{item.from}}</div>
            <div class="text" >时间：{{item.created_at}}</div>
            <index-icons class="index-icons" :goodsnum="item.mark" :commentnum="item.comment" :looknum="item.views"></index-icons>
          </div>
          </router-link>
        </el-col>
        <el-col :span="4">
          <div class="grid-content bg-purple right">
            <div v-if="item.status == '0'"  class="statustab wsh">{{item.status_text}}</div>
            <div v-else-if="item.status == '1'" class="statustab sh">{{item.status_text}}</div>
            <div v-else-if="item.status == '2'" class="statustab wtg">{{item.status_text}}</div>
            <div style="flex: 1;"></div>
            <div @click='handelDelect(item.id)' class="el-button delete">删 除</div>
          </div>
        </el-col>
      </el-row>
     <div class="page-box">
        <el-pagination
        background
        :page-size="page_size"
        :current-page="page"
        @current-change="handCurrentChange"
        layout="prev, pager, next"
        :total="listNum">
      </el-pagination>
     </div>
      <!-- <pagination class="pages" :listNum="listNum"></pagination> -->
    </div>
    <data-empty v-else></data-empty>
  </div>
</template>
<script>
import IndexIcons from "@/components/Icons"
import pagination from "@/components/Pagination"
import DataEmpty from '@/components/Data'
export default {
  name: 'WorksList',
  components: {
    IndexIcons,
    pagination,
    DataEmpty
  },
  data() {
    return {
        activeName: 'first',
        status:'',
        listNum:0,
        workList:{},
        page:1,
        page_size:10,
        dataEmpty:true
    }
  },
    created(){
        // this.getList(this.$data.page,this.$data.page_size)
        this.getWorks(1)
    },
  methods: {
    handleClick(tab, event) {
      switch (tab.name) {
        case 'first':
          this.$data.status = '';
          break;
        case 'second':
          this.$data.status = '1';
          break;
        case 'third':
          this.$data.status = '0';
          break;
        case 'fourth':
          this.$data.status = '2';
          break
      }

      this.page = 1;
      this.getWorks(1)



      return;
           // ''全部0未审核1是审核通过2是审核不通过
          this.$api.myWorks({'status':this.$data.status}).then(res => {
              //数据处理
              var arr = res.data.works_list;
              if(res.data.works_list == ''){
                this.dataEmpty = false
              }else{
                this.dataEmpty = true
              }
              for(var key in arr){
                if(arr[key].status == 0){
                  arr[key].status_text = '待审核'
                }else if(arr[key].status == 1){
                  arr[key].status_text = '已审核'
                }else if(arr[key].status == 2){
                  arr[key].status_text = '未通过'
                }
              }
              console.log(arr,"作品列表")
              this.$data.workList = arr
              this.$data.listNum = res.data.works_num
          }).catch(err => console.log(err))
      },
      getList(page,page_size){
          var data = {
              status:this.$data.status,
              page:page,
              page_size:page_size,
          }
          this.$api.myWorks(data).then(res => {
              //数据处理
              var arr = res.data.works_list;
              if(res.data.works_list == ''){
                this.dataEmpty = false
              }else{
                this.dataEmpty = true
              }
              for(var key in arr){
                if(arr[key].status == 0){
                  arr[key].status_text = '待审核'
                }else if(arr[key].status == 1){
                  arr[key].status_text = '已审核'
                }else if(arr[key].status == 2){
                  arr[key].status_text = '未通过'
                }
              }
              console.log(arr,"作品列表", res.data)
              this.$data.workList = arr
              this.$data.listNum = res.data.works_num
          }).catch(err => console.log(err))
      },
      handelDelect(id){
        var workId = id
        this.$confirm('此操作将永久删除该作品, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            this.$api.workDelete({id:workId}).then(res=>{
            if(res.code == 200 ){
              this.$message.success(res.message)
              // this.getList(this.$data.page,this.$data.page_size)
              // this.workList.length ===1 && this.getWorks(this.page)
             
             if(this.workList.length === 1) {
              this.page = this.page > 1 ? this.page - 1 : this.page;
              this.getWorks(this.page);
             }
              
            }else{
              this.$message(res.message)
            }
          }).catch(err => console.log(err))
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });


      },
      workDetailsInfo(id,type){
          console.log(id,type)
          this.$router.replace('/workdetails/'+id+'/'+type)
      },
      handCurrentChange(page){
        // 
        console.log(`page=${page}`)
        // this.getList(page, this.page_size)
        this.page = page;
        this.getWorks(page)
      },
      /**
       * 我的作品列表
       * @param {number} page 页数
       */
      async getWorks(page=1){
        try {

          let data = await this.$api.fetchMyWorksByStatus({
            params:{ 
              'per-page': this.page_size,
              'page': page
            },
            data:{
              status: this.status
            }
          });
          let { works_list , works_num } = data.data;
          this.dataEmpty = +works_num === 0 ? false : true;
          this.listNum = +works_num
          this.workList = works_list.map(item => {
            const STATUS = {
              0: '待审核',
              1:'已审核',
              2:'未通过'
            }
            item.status_text =  STATUS[item.status]
            return item;
          })
          // console.log('getworks', works_list)
        } catch (error) {
          console.error(error)
        }
      }
  }
}
</script>
<style scoped>
  .statustab{
    text-align: center;
    border-radius: 2px;
  }
  .works_box{
    width: 100%;
    height: 100%;
    padding: 40px;
    box-sizing: border-box;

  }
  .el-row{
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #EEEEEE;
  }
  .el-col {
    border-radius: 4px;
  }

  .left img{
    width: 100%;
    height: 190px;
    border-radius: 10px;
    object-fit: cover;
  }
  .left .cover{
    width: 100%;
    height: 190px;
    border-radius: 10px;
 
  }
  .left{
    position: relative;
  }
  .left label{
    position: absolute;
    display: inline-block;
    background: #000000;
    opacity: 0.5;
    color: white;
    border-radius: 10px;
    text-align: center;
    bottom: 2px;
  }
  .center .title{
    height: 14px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin: 20px 0px;
  }
  .center .text{
    height: 11px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    margin: 14px 0px;
  }
  .center .index-icons{
    margin-top: 30px;
  }
  .el-button {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .sh{
    background: #58B75B;
    color: #FFFFFF;
  }
  .wtg{
    background: #999999;
    color: #FFFFFF;
  }
  .wsh{
    background: #FFB463;
    color: #FFFFFF;
  }
  .right{
    height: 160px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    padding-top: 20px;
  }
  .delete{
    border: 1px solid #999999;
    box-sizing: border-box;
  }
  .pages{
    margin: 0 auto;
  }
  .page-box {
    display: flex;
    align-items: center;
    justify-content: center;

  }

  @media (min-width: 1024px){
    .left label{
        width: 90px;
        height: 34px;
        line-height: 34px;
      }
      .statustab{
        width: 100px;
        height: 35px;
        line-height: 35px;
      }
      .el-button {
        width: 100px;
        height: 40px;
        border-radius: 20px;
      }
      
    } /*>=1024的设备*/

    @media (min-width: 1100px) {
    
    } /*>=1100的设备*/
    @media (min-width: 1280px) {
      .left label{
        width: 60px;
        height: 24px;
        line-height: 24px;
      }
      .statustab{
        width: 64px;
        height: 25px;
        line-height: 25px;
      }
      .el-button {
        width: 70px;
        height: 30px;
        border-radius: 15px;
      }
      
    } /*>=1280的设备*/

</style>



// WEBPACK FOOTER //
// src/my/components/WorksList.vue